// Debug logging utility for thebemagugu cart system
// Toggle debug mode with: localStorage.setItem('TM_DEBUG', 'true')

const DEBUG_KEY = 'TM_DEBUG'
const DEBUG_PREFIX = '[TM]'

export const isDebugMode = () => {
  if (typeof window === 'undefined') return false
  return localStorage.getItem(DEBUG_KEY) === 'true'
}

export const debugLog = (message, data = null) => {
  if (!isDebugMode()) return

  const timestamp = new Date().toISOString().substr(11, 12)
  const logMessage = `${DEBUG_PREFIX} ${timestamp} ${message}`

  if (data) {
    console.log(logMessage, data)
  } else {
    console.log(logMessage)
  }
}

export const debugError = (message, error = null) => {
  if (!isDebugMode()) return

  const timestamp = new Date().toISOString().substr(11, 12)
  const logMessage = `${DEBUG_PREFIX} ${timestamp} ERROR: ${message}`

  if (error) {
    console.error(logMessage, error)
  } else {
    console.error(logMessage)
  }
}

export const debugWarn = (message, data = null) => {
  if (!isDebugMode()) return

  const timestamp = new Date().toISOString().substr(11, 12)
  const logMessage = `${DEBUG_PREFIX} ${timestamp} WARN: ${message}`

  if (data) {
    console.warn(logMessage, data)
  } else {
    console.warn(logMessage)
  }
}

// Helper to enable/disable debug mode
export const setDebugMode = (enabled) => {
  if (typeof window === 'undefined') return

  if (enabled) {
    localStorage.setItem(DEBUG_KEY, 'true')
    console.log(
      `${DEBUG_PREFIX} Debug mode ENABLED. Use tmDebug.off() to disable.`
    )
  } else {
    localStorage.removeItem(DEBUG_KEY)
    console.log(`${DEBUG_PREFIX} Debug mode DISABLED.`)
  }
}

// Convenience utilities for browser console
const debugUtilities = {
  on: () => setDebugMode(true),
  off: () => setDebugMode(false),
  status: () => {
    const enabled = isDebugMode()
    console.log(`${DEBUG_PREFIX} Debug mode is ${enabled ? 'ENABLED' : 'DISABLED'}`)
    return enabled
  },
  help: () => {
    console.log(`${DEBUG_PREFIX} Debug Utilities:
    tmDebug.on()     - Enable debug logging
    tmDebug.off()    - Disable debug logging  
    tmDebug.status() - Check current status
    tmDebug.help()   - Show this help`)
  }
}

// Export for global access in browser console
if (typeof window !== 'undefined') {
  window.tmDebug = debugUtilities
  
  // Show initial status
  if (isDebugMode()) {
    console.log(`${DEBUG_PREFIX} Debug mode is ENABLED. Use tmDebug.off() to disable.`)
  }
}